import { UserDocument } from './userDocuments.slice'
export const bankStatementsPane = {
  static: {
    statementMonthNoValue: 'N/A',
    uploadErrorInvalidDate:
      'The statement date must be earlier than the current month/year',
    uploadErrorNoFilesSelected: 'You must select at least 1 document to upload',
    uploadModalHeaderText: 'Upload Statements',
    uploadStatementFormYearLabel: 'Select Statement Year',
    uploadStatementFormMonthLabel: 'Select Statement Month',
  },
}

export const bookkeepingPane = {
  static: {
    modalDocumentTypeLabel: 'Select a Bookkeeping Document Type',
    modalDocumentDescriptionLabel:
      'If unsure, describe the purpose of this document',
    modalDocumentPlaceholder: 'Enter description...',
    modalNoDocumentTypesAvailable: 'No document types are available',
    documentType: {},
  },
}

export const taxPane = {
  static: {
    learnMoreTitle: 'Learn more about your Tax Files & Terminology',
    learnMoreBodyText: 'TBD',
    modalDocumentTypeLabel: 'Select a Tax Document Type',
    modalDocumentDescriptionLabel:
      'If unsure, describe the purpose of this document',
    modalDocumentPlaceholder: 'Enter description...',
    modalNoDocumentTypesAvailable: 'No document types are available',
    uploadModalHeaderText: 'Upload Tax Documents',
    formTypes: {
      taxReturn: 'Tax Return',
      taxForm1099: 'Form 1099',
      taxFormW2: 'Form W-2',
      taxFormK1: 'Form K-1',
      taxFormOther: 'Other Tax Form',
    },
  },
}

export const incorporationDocumentsPane = {
  static: {
    modalDocumentTypeLabel: 'Select Incorporation Document Type',
    modalDocumentDescriptionLabel:
      'If unsure, describe the purpose of this document',
    modalDocumentPlaceholder: 'Enter description...',
    modalNoDocumentTypesAvailable: 'No document types are available',
    uploadModalHeaderText: 'Upload Incorporation Documents',
  },
}

export const other = {
  static: {
    modalDocumentDescriptionLabel:
      'If unsure, describe the purpose of this document',
    modalDocumentPlaceholder: 'Enter description...',
    uploadModalHeaderText: 'Upload Documents',
    modalDocumentTypeLabel: 'Select A Document Type',
    modalNoDocumentTypesAvailable: 'No document types are available',
  },
}

/* Shared Components */
export const documentsSearchBar = {
  static: {
    placeholderText: 'Search document name',
  },
}

export const actionButton = {
  static: {
    confirmButtonLoadingText: 'Deleting...',
    confirmButtonNotLoadingText: 'Delete',
    deleteMenuItemText: 'Delete File',
  },
  dynamic: {
    confirmContent: (document: UserDocument) => {
      return `Are you sure you want to delete ${
        document.fileDescription || 'the selected document'
      }? Once deleted, this file cannot be retrieved.`
    },
  },
}

export const requiredDocumentUploadButton = {
  static: {
    buttonText: 'Upload',
  },
}
